import { PageModel } from "./PageModel";
import {carsConfig} from "../../Core/CarBuilderInfo/carBuilder";

class CarBuilderModel extends PageModel {
    private  _loading: boolean;
    private  _carConfig: any;
    constructor(props: string) {
        super(props);
        this._loading = true;
        this._carConfig = null;
    }

    public init = async () => {
        await new Promise(r => setTimeout(r, 3000));
        this._loading = false;
        this._carConfig = JSON.parse(JSON.stringify(carsConfig))
        this.forceUpdate()
    }

    public get loading(){
        return this._loading;
    }
    public get carConfig(){
        return this._carConfig;
    }
}

export {CarBuilderModel}
